import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const useEnrolledPageRedirection = ({ goalUID, querySlug }) => {
  const { goalInfo } = useGoalInfo(goalUID);
  const router = useRouter();
  useEffect(() => {
    // Slug Correction
    if (querySlug !== goalInfo?.slug)
      router.replace(
        '/goal/[goalSlug]/[goalUID]/enrolled',
        `/goal/${goalInfo?.slug}/${goalUID}/enrolled`,
        { shallow: true }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath]);
};

export default useEnrolledPageRedirection;
